import { render, staticRenderFns } from "./AyudaDescargaSmolt.vue?vue&type=template&id=a81ff716&scoped=true"
import script from "./AyudaDescargaSmolt.vue?vue&type=script&lang=js"
export * from "./AyudaDescargaSmolt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81ff716",
  null
  
)

export default component.exports